<div class="row">
  <div class="col-12">
    <h3 class="titulo">Atención Inmediata</h3>

    <div *ngIf="esPaginaEspecial" class="contenido-especial">
      <div class="row justify-content-center">
        <!-- Card 1 -->
        <div class="col-md-4 col-sm-12 mb-3 p-0">
          <div class="card custom-card" style="display: flex;align-items: center;">
            <div class="card-body text-center row p-3" style=" display: flex; align-items: center; width: 100%;">
              <div class="col-2" style="display: flex;justify-content: center;">
                <mat-icon
                  style="color: #000; font-size: 30px; display: flex; align-items: center;">person_outline</mat-icon>
              </div>
              <div class="col-10">
                <span style="font-size: 12px; line-height: normal; word-wrap: break-word;">
                  <b>Cantidad de usuarios en la fila</b>
                </span>
                <br>
                <span *ngIf="dataOnDemand?.data?.pacientesSinAtencionEnFila !== undefined"
                  style="font-weight: bold; font-size: 18px; line-height: normal; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ dataOnDemand?.data?.pacientesSinAtencionEnFila }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div class="col-md-4 col-sm-12 mb-3 p-0">
          <div class="card custom-card" style="display: flex;align-items: center;">
            <div class="card-body text-center row p-3" style=" display: flex; align-items: center; width: 100%;">
              <div class="col-2" style="display: flex;justify-content: center;">
                <mat-icon style="color: #000; font-size: 30px; display: flex; align-items: center;">schedule</mat-icon>
              </div>
              <div class="col-10">
                <span style="font-size: 12px; line-height: normal; word-wrap: break-word;">
                  <b>Tiempo promedio de atención</b>
                </span>
                <br>
                <span
                  style="font-weight: bold; font-size: 18px; line-height: normal; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ dataOnDemand?.data?.tiempoPromedio ?? 0 }} minutos.
                </span>

              </div>
            </div>
          </div>
        </div>

        <!-- Card 3 -->
        <div class="col-md-4 col-sm-12 mb-3 p-0">
          <div class="card custom-card" style="display: flex;align-items: center;">
            <div class="card-body text-center row p-3" style=" display: flex; align-items: center; width: 100%;">
              <div class="col-2" style="display: flex;justify-content: center;">
                <mat-icon
                  style="color: #000; font-size: 30px; display: flex; align-items: center;">directions_walk</mat-icon>
              </div>
              <div class="col-10 p-0">
                <span style="font-size: 12px; line-height: normal; word-wrap: break-word;">
                  <b>Tiempo estimado de espera para el último usuario en la fila</b>
                </span>
                <br>
                <span
                  style="font-weight: bold; font-size: 18px; line-height: normal; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  {{ dataOnDemand?.data?.tiempoEsperaTotal ?? 0 }} minutos.
                </span>

              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container>

        <div class="col-12 mb-3" *ngFor="let consulta of consultas_en_curso.data">
          <div class="card card-consulta">
            <!-- Encabezado con la etiqueta de Atención Inmediata -->
            <div class="card-header">
              <span class="badge badge-primary badge-color-ondemand">Atención Inmediata</span>
            </div>

            <!-- Contenido Principal -->
            <div class="card-body d-flex align-items-center pt-0">
              <!-- Imagen del Médico -->
              <div class="col-md-2 col-sm-12 doctor-img-container">
                <img class="doctor-img" [src]="URL_DOCUMENTS + consulta.medico.att_path" alt="profile-img"
                  title="profile-img">

              </div>

              <!-- Información de la consulta -->
              <div class="col-md-8 col-sm-12 info-container">
                <p class="fecha-hora">{{consulta.consulta.fechaCompleta}}</p>
                <p class="medico"><strong>Médico:</strong> {{ consulta.medico.nombre_medico }} {{
                  consulta.medico.apellido_paterno }} - Área médica -{{ consulta.medico.especialidad }}</p>
                <p class="paciente"><strong>Paciente:</strong> {{ consulta.paciente.nombre_usuario }} {{
                  consulta.paciente.use_paternal_surname }}</p>
              </div>

              <!-- Botón de Ver Detalle -->
              <div class="col-md-2 col-sm-12 boton-container">
                <button class="btn btn-primary btn-detalle" (click)="verDetalleConsulta(consulta)" style="background: #2babb7;
            border-radius: 30px !important;
            border-style: none;
            font-style: normal;
            font-size: 16px;
            line-height: 24px;
            color: #fff;
            font-family: 'Mulish';">Ver detalle</button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>


    </div>




    <h5 class="minititulo">Médicos Activos</h5>
  </div>
  <ng-container *ngIf="dataOnDemand.medicos?.length == 0">
    <div class="row cardInfo" style="display: flex; flex-direction: row; width: 100%;
    padding: 10px;">
      <div class="col-md-1 col-2" style="display: flex; justify-content: center; align-items: center;">
        <mat-icon style="color: #171994; font-size: 30px;">info</mat-icon>
      </div>
      <div class="col-md-11 col-10" style="align-self: center; padding-left: 0;">
        <p class="infoStyleText" style="text-align: justify;">No hay médicos activos para atención inmediata.</p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="dataOnDemand.medicos?.length > 0">
    <!-- Tarjetas de Médicos en Atención -->
    <div class="col-12" *ngFor="let doctor of medicosOnDemand">
      <div class="card doctor-card" [ngClass]="{'card-en-atencion':  doctor.horaInAtencion && doctor.horaOutAtencion == null, 
                  'card-disponible':  (doctor.horaInAtencion && doctor.horaOutAtencion != null) || 
                                     (doctor.horaInAtencion == null && doctor.horaOutAtencion == null)}">

        <div class="row align-items-center" style="width: 100%;">
          <!-- Imagen del Médico -->
          <div class="col-md-2 col-sm-4 text-center p-0">
            <img class="doctor-img" [src]="URL_DOCUMENTS + doctor.att_path" alt="profile-img" title="profile-img">
          </div>

          <!-- Información del Médico -->
          <div class="col-md-{{ usuario.typ_id == 8 ? 3 : 4 }} col-sm-8">
            <h5 class="doctor-name">{{ doctor.use_name }} {{ doctor.use_paternal_surname }}</h5>
            <span
              *ngIf="(doctor.sch_od_hora_in != null && doctor.sch_od_hora_out != null && doctor.sch_od_hora_in_manual == null)"
              class="especialidad" style="font-size: 12px;">Horario desde: {{ doctor.sch_od_hora_in }} - {{
              doctor.sch_od_hora_out }}</span>
            <span
              *ngIf="(doctor.sch_od_hora_in == null || doctor.sch_od_hora_out == null || doctor.sch_od_hora_in_manual)"
              class="especialidad">Habilitado desde: {{doctor.sch_od_hora_in_manual}}</span>
          </div>

          <!-- Estado del Médico -->
          <div class="col-md-2 col-sm-4">
            <span class="estado" [ngClass]="{
  'en-atencion': doctor.horaInAtencion && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente != null,
  'en-espera': doctor.horaInAtencion && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente == null,
  'por-iniciar': doctor.horaIngresoDoctor && doctor.horaInAtencion == null,
  'disponible': (doctor.horaInAtencion && doctor.horaOutAtencion != null) ||
                (doctor.horaInAtencion == null && doctor.horaOutAtencion == null && doctor.pausa_in == null),
  'en-pausa': doctor.pausa_in
}">
              ● {{ obtenerEstadoDoctor(doctor) }}
            </span>

            <!-- En consulta -->
            <div *ngIf="doctor.horaInAtencion && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente != null">
              <span class="especialidad">Tiempo en consulta: {{ doctor.tiempoEnConsulta }}</span>
            </div>
            <!-- Consulta por iniciar (aún no inicia llamada) -->
            <div *ngIf="doctor.horaInAtencion && doctor.horaIngresoDoctor && doctor.horaInicioDoctor == null">
              <span class="especialidad">Tiempo transcurrido: {{ doctor.tiempoPorIniciar }}</span>
            </div>

            <!-- En espera de paciente (llamada iniciada) -->
            <div *ngIf="doctor.horaInicioDoctor != null && doctor.horaIngresoDoctor !== null && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente == null">
              <span class="especialidad">Tiempo esperando al paciente: {{ doctor.tiempoEnEsperaPaciente }}</span>
            </div>


            <div *ngIf="doctor.horaOutAtencion != null">
              <span class="especialidad">Última atención: {{ doctor.horaOutAtencion }}</span>
            </div>

            <div *ngIf="doctor.pausa_in && !doctor.horaInAtencion && !doctor.horaOutAtencion">
              <span class="especialidad">Tiempo en pausa: {{ doctor.tiempoEnPausa }}</span>
            </div>
          </div>


          <!-- Especialidades -->
          <div class="col-md-{{ usuario.typ_id == 8 ? 3 : 3 }} col-sm-8 text-end"
            style="display: flex; flex-direction: column;">
            <span class="especialidad">Especialidades:</span>
            <span *ngFor="let especialidad of doctor.especialidades" class="disponible">● {{ especialidad.spe_name
              }}</span>
          </div>

          <!-- Switch para typ_id == 8 -->
          <div *ngIf="usuario.typ_id == 8" class="col-md-2 col-sm-12 text-center">
            <button style="background-color: #2babb7; color: white; border-radius: 20px; width: inherit;"
              mat-raised-button (click)="ConfigurarAgenda(doctor.doc_id)">
              Editar
              <mat-icon>edit_calendar</mat-icon>
            </button>

          </div>

        </div>
      </div>
    </div>

  </ng-container>




  <!-- Tabla de Pacientes en Espera -->
  <div class="col-12">
    <h5 class="minititulo">Pacientes en atención inmediata</h5>
  </div>
  <ng-container *ngIf="dataOnDemand.pacientes?.length == 0">
    <div class="row cardInfo" style="display: flex; flex-direction: row; width: 100%;
    padding: 10px;">
      <div class="col-md-1 col-2" style="display: flex; justify-content: center; align-items: center;">
        <mat-icon style="color: #171994; font-size: 30px;">info</mat-icon>
      </div>
      <div class="col-md-11 col-10" style="align-self: center; padding-left: 0;">
        <p class="infoStyleText" style="text-align: justify;">No hay pacientes en la fila de espera.</p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="dataOnDemand.pacientes?.length > 0">
    <mat-tab-group style="width: 100%;">
      <mat-tab *ngFor="let especialidad of especialidades" [label]="especialidad.nombre">
        <div class="col-12">
          <table mat-table [dataSource]="dataSources[especialidad.id]" class="mat-table">

            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef> # </th>
              <td mat-cell *matCellDef="let element"> {{element.index}} </td>
            </ng-container>

            <ng-container matColumnDef="fechaHoraIngreso">
              <th mat-header-cell *matHeaderCellDef> Fecha y Hora de Ingreso </th>
              <td mat-cell *matCellDef="let element"> {{element.fechaHoraIngreso}} </td>
            </ng-container>

            <ng-container matColumnDef="tiempoEspera">
              <th mat-header-cell *matHeaderCellDef> Tiempo de Espera </th>
              <td mat-cell *matCellDef="let element"> {{element.tiempoEspera}} </td>
            </ng-container>

            <ng-container matColumnDef="paciente">
              <th mat-header-cell *matHeaderCellDef> Paciente </th>
              <td mat-cell *matCellDef="let element"> {{element.use_name}} {{element.use_paternal_surname}}
                {{element.use_maternal_surname}}</td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let element"> {{element.sta_name}}</td>
            </ng-container>

            <ng-container matColumnDef="doctor">
              <th mat-header-cell *matHeaderCellDef> Doctor </th>
              <td mat-cell *matCellDef="let element"> {{element.nombre_doctor_asignado}}
                {{element.ap_paternal_doctor_asignado}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
            aria-label="Select page of periodic elements"></mat-paginator>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>


  <!-- Sección de Médicos No Disponibles -->
  <div class="col-12 mt-4" *ngIf="medicosOnDemandNoDisponibles.length > 0">
    <h5 class="minititulo">Médicos No Disponibles</h5>
  </div>

  <!-- Tarjetas de Médicos No Disponibles -->
  <div class="col-12" *ngFor="let doctor of medicosOnDemandNoDisponibles">
    <div class="card doctor-card card-no-disponible">
      <div class="row align-items-center" style="width: 100%;">

        <!-- Imagen del Médico -->
        <div class="col-md-2 col-sm-4 text-center p-0">
          <img class="doctor-img" [src]="URL_DOCUMENTS + doctor.att_path" alt="profile-img" title="profile-img">
        </div>

        <!-- Información del Médico -->
        <div class="col-md-3 col-sm-8">
          <h5 class="doctor-name">{{ doctor.use_name }} {{ doctor.use_paternal_surname }}</h5>
          <span class="especialidad">Estado: No Disponible</span>
        </div>

        <div class="col-md-2 col-sm-8 d-flex">
          <span *ngIf="doctor.sch_od_hora_in && doctor.sch_od_hora_out" class="especialidad">Horario agenda:</span>
          <br>
          <span *ngIf="doctor.sch_od_hora_in && doctor.sch_od_hora_out" class="especialidad">Fecha: {{
            doctor.sch_od_date }}</span>
          <br>
          <span *ngIf="doctor.sch_od_hora_in && doctor.sch_od_hora_out" class="especialidad">Hora: {{
            doctor.sch_od_hora_in }} - {{ doctor.sch_od_hora_out }}</span>
          <span *ngIf="!doctor.sch_od_hora_in && !doctor.sch_od_hora_out" class="especialidad d-flex">Sin agenda
            configurada</span>
        </div>

        <!-- Especialidades -->
        <div class="col-md-3 col-sm-8 text-end" style="display: flex; flex-direction: column;">
          <span class="especialidad">Especialidades:</span>
          <span *ngFor="let especialidad of doctor.especialidades" class="disponible">● {{ especialidad.spe_name
            }}</span>
        </div>

        <!-- Switch para cambiar estado (Solo para usuario typ_id == 8) -->
        <div *ngIf="usuario.typ_id == 8" class="col-md-2 col-sm-12 text-center">
          <button style="background-color: #2babb7; color: white; border-radius: 20px; width: inherit;"
            mat-raised-button (click)="ConfigurarAgenda(doctor.doc_id)">
            Editar
            <mat-icon>edit_calendar</mat-icon>
          </button>

        </div>

      </div>
    </div>
  </div>
</div>

<!-- Modal Detalle Consulta -->
<div class="modal fade" id="modalDetalleConsulta" tabindex="-1" aria-labelledby="modalDetalleConsultaLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="border: none;">
        <h5 class="modal-title tituloModal" id="modalDetalleConsultaLabel">Detalle de la Consulta</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body estiloBodyModal">
        <hr class="estiloHrModal">

        <!-- Datos Generales de la Consulta -->
        <p class="subTituloModal">Datos de la Consulta</p>
        <div class="row divBodyModal">
          <div class="col-4">
            <p class="letraNormalModal"><strong>Número:</strong> {{consulta_selected.consulta.id_consulta}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Fecha:</strong> {{consulta_selected.consulta.fechaCompleta}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Motivo:</strong> {{consulta_selected.consulta.reason}}</p>
          </div>
        </div>

        <hr class="estiloHrModal">

        <!-- Estado de la Consulta -->
        <p class="subTituloModal">Estado de la Consulta</p>
        <div class="row divBodyModal">
          <div class="col-4">
            <p class="letraNormalModal"><strong>Dispositivo Paciente:</strong>
              {{consulta_selected.conexion.dispositivo_paciente}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Hora Conexión Paciente:</strong>
              {{consulta_selected.conexion.hora_conexion_paciente}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Hora Conexión Médico:</strong>
              {{consulta_selected.conexion.hora_conexion_doctor || 'No Conectado'}}</p>
          </div>
        </div>

        <hr class="estiloHrModal">

        <!-- Datos del Paciente -->
        <p class="subTituloModal">Datos del Paciente</p>
        <div class="row divBodyModal">
          <div class="col-4">
            <p class="letraNormalModal"><strong>Nombre:</strong> {{consulta_selected.paciente.nombre_usuario}}
              {{consulta_selected.paciente.use_paternal_surname}} {{consulta_selected.paciente.use_maternal_surname}}
            </p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>RUT:</strong> {{consulta_selected.paciente.rut}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Teléfono:</strong> {{consulta_selected.paciente.movil_phone}}</p>
          </div>
        </div>

        <hr class="estiloHrModal">

        <!-- Datos del Médico -->
        <p class="subTituloModal">Datos del Médico</p>
        <div class="row divBodyModal">
          <div class="col-4">
            <p class="letraNormalModal"><strong>Nombre:</strong> {{consulta_selected.medico.nombre_medico}}
              {{consulta_selected.medico.apellido_paterno}} {{consulta_selected.medico.apellido_materno}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Especialidad:</strong> {{consulta_selected.medico.especialidad}}</p>
          </div>
          <div class="col-4">
            <p class="letraNormalModal"><strong>Teléfono:</strong> {{consulta_selected.medico.movil_phone}}</p>
          </div>
        </div>

        <hr class="estiloHrModal">

        <div class="text-center">
          <button type="button" class="btn botonCancelar" data-dismiss="modal" (click)="cerrarModal()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- horaIngresoDoctor: doctor acepta (consulta por iniciar)
horaInAtencion: medio entro a la videollamda sin iniciar
horaInicioDoctor: doctor inicia videollamda
horaIngresoPaciente: paciente entra a la videollamada (inicia consulta) -->